// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"jB-z","expressButtonContainerWithPayPal":"kB-z","expressButton":"lB-z","or":"mB-z"};